<template>
    <!-- 对话框 -->
    <el-drawer title="详情" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="1000px">
        
        

        <div class="container">

            <template>

                <div class="tableScroll">
                    <el-table 
                            :data="tableData" 
                            class="table" 
                            ref="multipleTable" 
                            header-cell-class-name="table-header"
                            
                            
                >


                        <el-table-column type="index" label="序号">
                        </el-table-column>

                        <el-table-column prop="phone" label="用户手机号" min-width="120">
                        </el-table-column>

                        <el-table-column  prop="name" label="用户昵称" min-width="130">
                        </el-table-column>

                        <el-table-column  prop="create_time" label="登录时间" min-width="100">
                        </el-table-column>


                </el-table>

                <div class="pagination">

                     <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="pages_function"
                        :current-page="search_data_children.page"
                        :page-sizes="[10, 20, 30, 40 ,50]"
                        :page-size="search_data_children.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="result_data_children.count">
                    </el-pagination>

                </div>
                </div>

                

                  

                <!-- 分页组件 -->
                
                
                
            </template>
              <!-- 对话框底部按钮 -->
                <div style="display: flex;justify-content: center">
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
        </div>
    </el-drawer>
</template>

<script>

    var _this;
    export default {
        props: {
            'isShow': Boolean,
            'data':''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;
                _this.search_data_children.invite_code = _this.data;

                _this.inviteCustomerList()

            },
        },
        data() {
            return {


                show: false,

                //存放表格数据
                tableData: [],

                
                //获取用户列表的数据
                search_data_children: {
                    //当前页数
                    page: 1,
                    //每页显示多少条数据
                    limit: 10,
                    invite_code: '',
                    created_at: ''

                },
                result_data_children: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    } ,
                    
                }

                
                    
                

            };
        },
        created() {

            _this = this;
            _this.inviteCustomerList();

        },
        methods: {
                

            // 关闭方法
            closeDialog() {
                _this.show = false;
                
               
            },
            searchInviteCustomerList(){

                _this.search_data_children.page = 1;

                _this.inviteCustomerList();

            },

            inviteCustomerList() {
                
                _this
                    .$post('/Invitecode/getInviteCustomerList', _this.search_data_children, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data_children = res;


                    })
                    .catch((err) => {});
            },
            //页码值改变
            pages_function(search_data) {
                //赋值
                _this.search_data_children.page = search_data;

                console.log(_this.search_data_children.page);

                //初始化列表
                _this.inviteCustomerList();
            },

            //下拉条（每页显示多少数据）变化
			handleSizeChange(val) {

                console.log(val);

				_this.search_data_children.limit = val;

                _this.inviteCustomerList();

			},

            


        

           
        }

 };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }

    .tableScroll{
        height: 700px;
        overflow: hidden;
        overflow-y: scroll;
    }
    .table{
        margin-top:50px
    }
</style>